module.exports = {
  "acq-0140": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b"
      ]
    }
  },
  "acq-0142": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a",
        "variant_b"
      ]
    }
  },
  "acq-0143": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant_a"
      ]
    }
  },
  "acq-0144": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant"
      ]
    }
  },
  "wp-0078": {
    "identifierType": "UTK",
    "maxAge": 0,
    "parameters": {
      "group": [
        "control",
        "variant"
      ]
    }
  }
};